import { getEnv, RestHandler, getCsrfToken } from '@ctct/ctct-helpers';

import axios from '../../../axiosConfig';

/**
NOTE: The billing job runs at 2:00 AM Eastern or 3:00 AM Eastern depending on the account. If it fails,
an attempt is made again at 2:00 PM Eastern or 3:00 PM Eastern.

During the summer, 5:30 AM UTC is equivalent to 1:30 AM Eastern. During the winter, 5:30 AM UTC is
equivalent to 12:30 AM Eastern. This cutoff of 5:30 AM UTC was selected so that cancellations would
always be processed before billings, regardless of whether Daylight Saving Time is active. We could
approach this with greater precision, but the additional complexity would likely introduce bugs that
would take a while to figure out.

-- Ryan Kennedy 2024-11-21
*/
const CUTOFF_TIME_UTC = { hours: 5, minutes: 30 };

const getBaseUrl = () => {
  if (getEnv() === 'local') {
    return 'https://localhost:9000/v1/billing';
  }

  return `https://app${getEnv()}constantcontact.com/v1/billing`;
};

const getUrl = (path) => `${getBaseUrl()}/${path[0] !== '/' ? '/' : ''}${path}`;
const options = { headers: {} };
const token = getCsrfToken();

if (getEnv() !== 'local') {
  options.headers['X-CSRF-Token'] = token;
}

const restHandler = new RestHandler(getBaseUrl(), options);

const getActivePromotions = () => restHandler.get(`/promotions/active`);

const setPromotion = ({ promoCode, username }) =>
  axios.post(getUrl(`/promotion/${promoCode}?updateBy=${username}`), {});

const getBillingDate = () => axios.get(getUrl(`/billingdate`), { responseType: 'json' });

function getNextBillingCycleTimestamp() {
  return getBillingDate().then((response) => {
    const unixTimestamp = response.data;
    const date = new Date(unixTimestamp);

    return new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      CUTOFF_TIME_UTC.hours,
      CUTOFF_TIME_UTC.minutes,
      0,
      0
    ).toISOString();
  });
}

export default { getActivePromotions, setPromotion, getBillingDate, getNextBillingCycleTimestamp };
